import thumbnailStyles from "../Components/Thumbnail.module.css";
import { motion } from 'framer-motion';
import LazyLoad from 'react-lazyload';
const Thumbnail = ({ imgSrc, title }) => (
    <LazyLoad height={200}>
        <motion.div whileHover={{ scale: 1.05 }} className="thumbnail">
      <div className={`${thumbnailStyles.thumbnail}`}>
        <img src={imgSrc} alt={title} />
        {/* <h4>{title}</h4> */}
      </div>
      </motion.div>
    </LazyLoad>
  );
  export default Thumbnail;